module.exports = __webpack_public_path__ + "static/media/img-step1@2x.06c3caaa.png";